let language = {
    300620: "没有匹配的定价表",
};

export { language }
